var styles = [".center[_ngcontent-%COMP%]{max-width:300px;margin:auto;padding-top:40vh}"];
export { styles as styles };
